import { Hero } from '../components/Hero';
import { Pricing } from '../components/Pricing';
import { SEO } from '../components/SEO';
import { SEOContent } from '../components/SEOContent';
import { Services } from '../components/Services';
import { MainLayout } from '../layouts/MainLayout';

export function LandingPage() {
  return (
    <>
      <SEO />
      <MainLayout>
        <Hero />
        <Services />
        <Pricing />
        <SEOContent />
      </MainLayout>
    </>
  );
}
